import Service from "@ember/service";
import { i18n } from "discourse-i18n";

export default class WazeSnackbarService extends Service {
  show(messageKey) {
    let snackbar = document.getElementById("wz-global-snackbar");
    if (!snackbar) {
      snackbar = document.createElement("wz-snackbar");
      snackbar.id = "wz-global-snackbar";
      document.body.appendChild(snackbar);
    }
    snackbar.textContent = i18n(messageKey);

    if (typeof snackbar.showSnackbar === "function") {
      snackbar.showSnackbar();
    } else {
      customElements.whenDefined("wz-snackbar").then(() => {
        snackbar.showSnackbar?.();
      });
    }
  }
}
